import { v4 as uuidv4 } from 'uuid';

export function ProductSellingPrice(props = {}) {
	return {
		componentName: 'ProductSellingPrice',
		componentId: uuidv4(),
		props: Object.assign(
			{
				markers: [],
				message: '',
				blockClass: 'product-selling-price',
				alwaysShow: false,
			},
			props,
		),
		childrenComponents: [],
	};
}
